(function () {

  // Only run on cart page
  if (!window.location.pathname.startsWith('/cart')) return;

  let debounceTimer = null;
  let isCleaning = false;

  async function cleanOrphanedAddons() {
    if (isCleaning) return;
    isCleaning = true;
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();

      // Build set of all variant IDs currently in cart
      const variantIds = new Set(cart.items.map(item => String(item.variant_id)));

      // Find add-ons whose base product is no longer in the cart
      const orphans = cart.items.filter(item => {
        const linked = String((item.properties || {})['_linked_to'] || '');
        return linked && !variantIds.has(linked);
      });

      if (orphans.length === 0) {
        isCleaning = false;
        return;
      }

      // Remove each orphaned add-on
      for (const item of orphans) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      }

      // Reload to show cleaned cart
      window.location.reload();
    } catch (e) {
      console.error('Cart addon guardian error:', e);
      isCleaning = false;
    }
  }

  function scheduleCheck() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(cleanOrphanedAddons, 400);
  }

  function init() {
    // Run on page load
    cleanOrphanedAddons();

    // Watch for Krown's AJAX cart updates changing the DOM
    const target = document.querySelector('.cart-section') || document.body;
    const observer = new MutationObserver(scheduleCheck);
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
